// import InputCatalogoCuentas from '../../util/Inputs/InputCatalogoCuentas';
// import SelectCheckbox from '../../util/SelectCheckbox';
// import instanciaAxios from '../../../miscelaneo/instanciaAxios';
const FuncionesAjusteInventario = () => {

    function generarCamposFormulario(surcusales,motivosAjuste) {   
    return[

        { id: "id_sucursal", 
          type: "select", 
          label: "Sucursal", 
          placeholder: "Seleccione sucursal de origen", 
          seccion: "Información del ajuste de inventario",
          options: surcusales.map(sucursal => ({ label: sucursal.descripcion, value: sucursal.id_sucursal })),
          required: true
        },
        { id: "fecha_hora", type: "datetime-local", label: "Fecha y hora", placeholder: "Fecha y hora", default: "now", seccion: "Información del ajuste de inventario", required: true },
        { id: "comentario", type: "texttarea", label: "Comentario", placeholder: "Comentario", seccion: "Comentario del ajuste", required: false }, 
        { id: "id_motivo_ajuste_inventario",
          type: "select", 
          label: "Motivo", 
          placeholder: "Seleccione motivo de ajuste", 
          seccion: "Información del ajuste de inventario" ,
          options: motivosAjuste.map(motivo => ({ label: motivo.descripcion, value: motivo.id_motivo_ajuste_inventario })),
          required: true
        },
        { id: "usuario", type: "text", label: "Creado/Modificado por:", placeholder: "Usuario", seccion: "Información del ajuste de inventario", disabled:true, required: false }, 

    ]
    
    }










        return{generarCamposFormulario }

}

export default FuncionesAjusteInventario